export default {
  signworkflows: state => state.signworkflows,
  searchParams: state => state.searchParams,
  pagination: state => state.pagination,
};



// WEBPACK FOOTER //
// ./src/store/modules/parapheurs/getters.js